import { render, staticRenderFns } from "./TimeTableBreak.vue?vue&type=template&id=33ff27ec"
import script from "./TimeTableBreak.vue?vue&type=script&lang=js"
export * from "./TimeTableBreak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports